import {CHAT_MODE} from "../../context/actionTypes";

export function isChatMode(mode: string) {
    return mode === CHAT_MODE.QUERY || mode === CHAT_MODE.QUERY_WITHOUT_RAG;
}